import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  aiSuggestions: [],
  aiFilters: {
    mealType: '',
    dietaryType: [],
    preferQuickMeals: false,
    lowCalorie: false,
    highProtein: false,
    cuisinePreference: []
  },
  userData: {
    preferences: {
      favoriteCuisines: ['indian'],
      preferQuickMeals: false,
      highProtein: false,
      lowCalorie: false
    },
    recentMeals: [],
    weather: 'warm' // This would come from a weather API in a real implementation
  },
  loading: false,
  error: null
};

const aiMealsSlice = createSlice({
  name: 'aiMeals',
  initialState,
  reducers: {
    fetchAiSuggestionsStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchAiSuggestionsSuccess(state, action) {
      state.aiSuggestions = action.payload;
      state.loading = false;
    },
    fetchAiSuggestionsFailure(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    updateAiFilters: (state, action) => {
      state.aiFilters = { ...state.aiFilters, ...action.payload };
      // Make sure the payload is fully applied to the state
      Object.keys(action.payload).forEach(key => {
        state.aiFilters[key] = action.payload[key];
      });
      console.log('Updated AI filters:', state.aiFilters);
    },
    updateUserData(state, action) {
      state.userData = { ...state.userData, ...action.payload };
    },
    addToRecentMeals(state, action) {
      // Keep only the last 5 meals in history
      state.userData.recentMeals = [
        action.payload,
        ...state.userData.recentMeals.slice(0, 4)
      ];
    },
    toggleAiFilterPreference(state, action) {
      const { preference, value } = action.payload;
      if (preference in state.userData.preferences) {
        state.userData.preferences[preference] = value !== undefined ? value : !state.userData.preferences[preference];
      }
    },
    toggleCuisinePreference(state, action) {
      const cuisine = action.payload;
      const cuisines = state.userData.preferences.favoriteCuisines;
      
      if (cuisines.includes(cuisine)) {
        state.userData.preferences.favoriteCuisines = cuisines.filter(c => c !== cuisine);
      } else {
        state.userData.preferences.favoriteCuisines = [...cuisines, cuisine];
      }
    }
  }
});

export const {
  fetchAiSuggestionsStart,
  fetchAiSuggestionsSuccess,
  fetchAiSuggestionsFailure,
  updateAiFilters,
  updateUserData,
  addToRecentMeals,
  toggleAiFilterPreference,
  toggleCuisinePreference
} = aiMealsSlice.actions;

// Selectors
export const selectAiSuggestions = state => state.aiMeals.aiSuggestions;
export const selectAiFilters = state => state.aiMeals.aiFilters;
export const selectUserData = state => state.aiMeals.userData;
export const selectAiLoading = state => state.aiMeals.loading;

export default aiMealsSlice.reducer;
